import React from 'react';
import get from 'lodash/get';
import { StyledRadio } from '../../../../atoms/Forms/Radio';
import useStyles from './style';
import Typography from '../../../../atoms/Typography';

const MatrixChoiceGroup = ({
  parentQuestion = {},
  questions = [],
  responses = [],
  handleChange = () => { }
}) => {
  const classes = useStyles();

  const children = questions.filter(
    (question) => get(question, 'sourceParentQuestinIdentifier', 'questionSourceParentQuestinIdentifier') === get(parentQuestion, 'sourceQuestinIdentifier', 'parentSourceQuestinIdentifier')
  );
  return (
    <div className={classes.root} key={get(parentQuestion, 'questionId', 'parentQuestionId')}>
      <label className="questionLabel">{get(parentQuestion, 'questionText', 'parentQuestionText')}</label>
      <table className="matrixTable">
        <thead>
          <tr>
            <th></th>
            {(get(parentQuestion, 'options', []) || []).map((option, index) => (
              <th key={`${option}-${index}`}>
                <Typography className={'optionLabel'}> {option}</Typography>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {children.map((child, index) => (
            <tr key={`childQuestion-${index}`}>
              <td className='questionStatement'>{get(child, 'questionText', '')}</td>
              {(get(parentQuestion, 'options', []) || []).map((option, childIndex) => (
                <td className='radioTableData' key={`childoption-${childIndex}`}>
                  <StyledRadio
                    name={child.questionId}
                    value={option}
                    checked={responses[child.questionId] === option}
                    onChange={() => handleChange(child.questionId, option)}
                  />

                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default MatrixChoiceGroup
